import { render } from "./ProjectsPage.vue?vue&type=template&id=66ab00c2&scoped=true"
import script from "./ProjectsPage.vue?vue&type=script&lang=js"
export * from "./ProjectsPage.vue?vue&type=script&lang=js"

import "./ProjectsPage.vue?vue&type=style&index=0&id=66ab00c2&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ab00c2"]])

export default __exports__